export const formatInputNumber = (num: number | undefined | null, decimals = 3): string => {
  if (num === undefined || num === null) {
    return '';
  }
  // Round to specified decimal places, then remove trailing zeros
  const rounded = Number(num).toFixed(decimals);
  // Remove trailing zeros and trailing decimal point
  return parseFloat(rounded).toString();
};

export const toDegrees = (rad: number) => (rad * 180) / Math.PI;

export const toRadians = (deg: number) => (deg * Math.PI) / 180;
